import React,{ Component } from 'react';

import {
  FormGroup,
  Button,
  Row,
  Col,
  Label,
  Input,
  FormText
} from 'reactstrap';

import DateInput from 'react-datepicker';
import Form from '../../../shared/components/Form';
import moment from 'moment';
import TutorialPopover from '../../../shared/components/TutorialPopover';

class CampaignStartDateForm extends Component {
  constructor(){
    super();

    this.state = {
      validationMessages:{},
      launchDate:moment(),
      endDate:null,
      hasEndDate:false,
      isShowingPopover:false
    };
  }

  componentDidMount(){
    if(this.props.activeCampaignEndDate){
      this.setState({
        hasEndDate:true,
        endDate:moment(this.props.activeCampaignEndDate)
      });
    }

    if(this.props.activeCampaignLaunchDate){
      this.setState({
        launchDate:moment(this.props.activeCampaignLaunchDate)
      });
    }
  }

  componentWillReceiveProps(nextProps){
    if(!this.props.open && nextProps.open){
      window.setTimeout(() => this.setState({isShowingPopover:true}),500);
    }

    if(this.props.open && !nextProps.open){
      this.setState({isShowingPopover:false});
    }
  }

  handleSubmit(){
    const data = {
      launchDate:this.state.launchDate ? this.state.launchDate.toISOString() : '',
      endDate:this.state.endDate ? this.state.endDate.toISOString() : ''
    };

    const validationMessages = {};

    if(!data.launchDate || data.launchDate.length === 0){
      validationMessages['launchDate'] = 'Launch date is required';
    }

    if(Object.keys(validationMessages).length > 0){
      this.setState({validationMessages:validationMessages});
      this.props.onSubmit(data);
    } else {
      this.setState({validationMessages:{}});
      this.props.onSubmit(data);
    }
  }

  handleHasEndDateClick(event){
    if(event.target.checked){
      if(this.state.launchDate){
        this.setState({
          hasEndDate:true
        });        
      } else {
        const oneWeekFromLaunch = this.state.launchDate.clone().add(1,'weeks');

        this.setState({
          hasEndDate:true,
          endDate:this.state.endDate || oneWeekFromLaunch
        });
      }
    } else {
      this.setState({
        endDate:false,
        hasEndDate:false
      });
    }
  }

  render(){
    const { launchDate, endDate, hasEndDate, isShowingPopover } = this.state;

    const {validationMessages} = this.state;

    return (
      <Form onSubmit={(data) => this.handleSubmit(data)}>
        <TutorialPopover
          open={isShowingPopover && this.props.isShowingTutorial}
          target='HasEndDateCheckbox'
          onCloseClick={() => this.setState({isShowingPopover:false})}
          title='Experience Date'
        >
          <p>
            When would you like your experience to run?  You can also not set an end date and let it run until your budget has been completed.
          </p>
        </TutorialPopover>
        <div id='HasEndDateCheckbox'>
          <Row>
            <Col xs='4'>
              <FormGroup>
                <DateInput
                  className='form-control'
                  minDate={moment()}
                  maxDate={endDate}
                  selected={launchDate}
                  onChange={(d) => this.setState({launchDate:d})}
                />
              </FormGroup>
            </Col>
            <Col xs='4'>
              <FormGroup>
                <DateInput
                  className='form-control'
                  minDate={this.state.launchDate || moment()}
                  selected={endDate}
                  onChange={(d) => this.setState({endDate:d})}
                  disabled={!hasEndDate}
                />
              </FormGroup>
            </Col>
            <Col xs='4'>
              <FormGroup check>
                <Label id='HasEndDateCheckbox' check>
                  <Input 
                    type='checkbox'
                    checked={hasEndDate}
                    onClick={(e) => this.handleHasEndDateClick(e)}
                  />
                  Has end date
                </Label>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs='12' className='LaunchDateWarning'>
              {validationMessages['launchDate'] && (
                <FormText className='DangerFeedback'>{validationMessages['launchDate']}</FormText>
              )}
            </Col>
          </Row>
        </div>
        <Button size='sm' color='primary'>
          &nbsp;&nbsp;Save&nbsp;&nbsp;
        </Button>
      </Form>
    )
  }
}

CampaignStartDateForm.defaultProps = {
  isShowingTutorial:true
};

export default CampaignStartDateForm;



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignCreation/components/CampaignStartDateForm.js